// SettingsIntegrationsPane.jsx

import React from 'react';

// Pages
import Api from 'pages/Api';

/**
 * SettingsIntegrationsPane
 *
 * Renders controls for managing third-party integrations connected to the workspace.
 *
 * @param {object} theme - Active theme tokens for dynamic styling.
 * @param {object} workspace - Active workspace model.
 *
 * @returns {ReactNode} The rendered integrations settings pane.
 */
const SettingsIntegrationsPane = React.memo(({
    theme,
    workspace,
}) => {

    // ----- RENDER ----- //

    return (
        <>
            <div className="settings-modal-pane-header">
                <div className="settings-modal-pane-header-left">
                    <div className="settings-modal-pane-title" style={{ color: theme.foreground }}>
                        Integrations
                    </div>
                    <div className="settings-modal-pane-subtitle" style={{ color: theme.foregroundMuted }}>
                        Manage third-party integrations connected to this workspace.
                    </div>
                </div>
            </div>

            <div className="settings-modal-pane-contents">
                <div className="settings-modal-embedded-panel">
                    <Api />
                </div>

            </div>
        </>
    );
});

// Dev Tools
SettingsIntegrationsPane.displayName = 'SettingsIntegrationsPane';

export default SettingsIntegrationsPane;